import React, { useState, useEffect } from "react";
import simpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hitSubmitContactUsApi } from "../../../Redux/Common/ContactUsSlice";
import { showToast } from "../../../Helper/Toast";
import BrowseIcon from "../../../assets/img/Browse icon.svg";
import Loader from "../../Loader/Loader"; // adjust the path
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";

const ContactUs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    attachments: null,
  });

  const [errors, setErrors] = useState({});
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Handle file selection
  const handleFileChange = (event) => {
    //console.log("handleFileChange calling");
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    // Create a preview URL for the selected image
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setImageUrl(previewUrl);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    //console.log("handleSubmit called");
    e.preventDefault();

    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      //console.log("Form submitted:", formData);
      dispatch(hitSubmitContactUsApi(formData)).then((response) => {
        if (response.payload?.status === true) {
          showToast(response.payload?.message, "success");
        } else {
          showToast(response.payload?.message || "Submission failed", "error");
        }
      });

      setFormData({
        name: "",
        email: "",
        message: "",
        attachments: null,
      });
      setFileName("");
    } else {
      setErrors(newErrors);
    }
  };

  // UseEffect to trigger upload when `file` changes
  useEffect(() => {
    if (file) {
      //console.log("file handl starts", file);
      uploadFile();
    }
  }, [file]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    setLoading(true);
    if (file) {
      //console.log("myfile", file);
      const formData = new FormData();
      formData.append("myfile", file);
      try {
        const response = await dispatch(hitUploadMedia(formData));
        setLoading(false);
        setFileName(file.name);
        setFormData((prev) => ({
          ...prev,
          image: response.payload?.data?.[0].url || "",
        }));
        //  setFileName(file.name);
        showToast("File uploaded successfully", "success");
      } catch (error) {
        setLoading(false);
        console.error("File upload error:", error);
      }
    }
  };


  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <div className="custom_container">
      <div className="contact-page">
        <div className="contact-page__header">
          <div className="logo">
            <img src={simpleRenovate} alt="SimpleRenovate" />
          </div>
          <h1 className="page-title">Contact our friendly team</h1>
          <p className="page-subtitle">Let us know how we can help</p>
        </div>

        <div className="contact-page__content">
          <div className="form-container">
            <h2 className="form-container__title">Contact us</h2>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">
                    Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className={`form-input ${errors.name ? "error" : ""}`}
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && (
                    <span className="error-message">{errors.name}</span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <span className="error-message">{errors.email}</span>
                  )}
                </div>
              </div>

              {/* <div className="form-group">
                <label htmlFor="number" className="form-label">
                  Number <span className="required">*</span>
                </label>
                <input
                  type="tel"
                  id="number"
                  name="number"
                  className={`form-input ${errors.number ? "error" : ""}`}
                  placeholder="Your phone number"
                  value={formData.number}
                  onChange={handleChange}
                />
                {errors.number && (
                  <span className="error-message">{errors.number}</span>
                )}
              </div> */}

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  className={`form-textarea ${errors.message ? "error" : ""}`}
                  placeholder="How can we help you?"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && (
                  <span className="error-message">{errors.message}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="attachments" className="form-label">
                  Attachment(s)
                </label>
                <div className="file-upload">
                  <input
                    type="file"
                    id="attachments"
                    name="attachments"
                    className="file-input"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="attachments" className="file-label">
                    <span className="file-icon">
                      <img src={BrowseIcon} alt="Browse icon" />
                    </span>
                    <span className="file-button">Browse</span>
                  </label>
                  {fileName && <span className="file-name">{fileName}</span>}
                </div>
              </div>

              <div className="text-center text-md-start">
                <button type="submit" className="submit-button">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
